(function () {

// import barba from '@barba/core';
// import gsap from 'gsap';
// barba.init({
//   transitions: [{
//     name: 'opacity-transition',
//     leave(data) {
//       return gsap.to(data.current.container, {
//         opacity: 0
//       });
//     },
//     enter(data) {
//       return gsap.from(data.next.container, {
//         opacity: 0
//       });
//     }
//   }],
//   views: [
//     {
//       namespace: "home",
//       afterEnter(data) {
//         startDVD();
//       },
//       beforeLeave(data) {}
//     },
//     {
//       namespace: "hire",
//       afterEnter(data) {
//         // setUpModal();
//         // registerAllHireSliders();
//         // addHireFormSubmitListener();
//         // setUpFormValidation();
//       },
//     },
//     {
//       namespace: "events",
//       afterEnter(data) {
//         // reloadFilters();
//       },
//     },
//     {
//       namespace: "whats-here",
//       afterEnter(data) {
//         // registerAllSliders();
//       },
//     },
//   ],
// });
// MOBILE MENU
function $2e011c8e26481ef3$var$showMenu() {
    document.querySelector("#navbarNavDropdown").style.display = "block";
    document.querySelector("#close").style.display = "block";
    document.querySelector("#open").style.display = "none";
    document.querySelector("body").style.overflow = "hidden";
    document.querySelector("body").style.position = "fixed";
    document.querySelector("html").style.overflow = "hidden";
    document.querySelector("html").style.position = "fixed";
}
function $2e011c8e26481ef3$var$hideMenu() {
    document.querySelector("#navbarNavDropdown").style.display = "none";
    document.querySelector("#close").style.display = "none";
    document.querySelector("#open").style.display = "block";
    document.querySelector("body").style.overflow = "auto";
    document.querySelector("body").style.position = "relative";
    document.querySelector("html").style.overflow = "auto";
    document.querySelector("html").style.position = "relative";
}
// HIDE SUBMIT BUTTON
function $2e011c8e26481ef3$var$hideSubmit() {
    document.querySelector("#mc-submit").style.opacity = "0";
}
// CONSENT DROP DOWN
function $2e011c8e26481ef3$var$consentDropDown() {
    document.getElementById("hidden-consent").style.opacity = "1";
}
// Menu event listeners
var $2e011c8e26481ef3$var$openMobMenuButton = document.getElementById("open");
var $2e011c8e26481ef3$var$closeMobMenuButton = document.getElementById("close");
$2e011c8e26481ef3$var$openMobMenuButton.addEventListener("click", $2e011c8e26481ef3$var$showMenu);
$2e011c8e26481ef3$var$closeMobMenuButton.addEventListener("click", $2e011c8e26481ef3$var$hideMenu);
// Mailing list signup event listeners
var $2e011c8e26481ef3$var$mailingListInput = document.getElementById("mce-EMAIL");
var $2e011c8e26481ef3$var$mailingListSubmit = document.getElementById("mc-embedded-subscribe");
$2e011c8e26481ef3$var$mailingListInput.addEventListener("input", $2e011c8e26481ef3$var$consentDropDown);
$2e011c8e26481ef3$var$mailingListSubmit.addEventListener("click", $2e011c8e26481ef3$var$hideSubmit);
var $2e011c8e26481ef3$var$colors = [];
const $2e011c8e26481ef3$var$elements = document.querySelectorAll(".floating-link");
$2e011c8e26481ef3$var$elements.forEach((item)=>{
    if (item.getAttribute("data-video") != null) $2e011c8e26481ef3$var$colors.push(item.getAttribute("data-video"));
});
var $2e011c8e26481ef3$var$box = document.getElementById("dvd");
var $2e011c8e26481ef3$var$win = window, $2e011c8e26481ef3$var$currentColor = Math.floor(Math.random() * $2e011c8e26481ef3$var$colors.length), $2e011c8e26481ef3$var$ww = $2e011c8e26481ef3$var$win.innerWidth, $2e011c8e26481ef3$var$wh = $2e011c8e26481ef3$var$win.innerHeight, $2e011c8e26481ef3$var$translateX = Math.floor(Math.random() * $2e011c8e26481ef3$var$ww), $2e011c8e26481ef3$var$translateY = Math.floor(Math.random() * $2e011c8e26481ef3$var$wh), $2e011c8e26481ef3$var$boxWidth = $2e011c8e26481ef3$var$box.offsetWidth, $2e011c8e26481ef3$var$boxHeight = $2e011c8e26481ef3$var$box.offsetHeight, $2e011c8e26481ef3$var$boxTop = $2e011c8e26481ef3$var$box.offsetTop, $2e011c8e26481ef3$var$boxLeft = $2e011c8e26481ef3$var$box.offsetLeft, $2e011c8e26481ef3$var$xMin = -$2e011c8e26481ef3$var$boxLeft, $2e011c8e26481ef3$var$yMin = -$2e011c8e26481ef3$var$boxTop, $2e011c8e26481ef3$var$xMax = $2e011c8e26481ef3$var$win.innerWidth - $2e011c8e26481ef3$var$boxLeft - $2e011c8e26481ef3$var$boxWidth, $2e011c8e26481ef3$var$yMax = $2e011c8e26481ef3$var$win.innerHeight - $2e011c8e26481ef3$var$boxTop - $2e011c8e26481ef3$var$boxHeight, $2e011c8e26481ef3$var$request = null, $2e011c8e26481ef3$var$direction = "se", $2e011c8e26481ef3$var$speed = 3, $2e011c8e26481ef3$var$timeout = null;
if (window.innerWidth < 800) $2e011c8e26481ef3$var$speed = 1.5;
var $2e011c8e26481ef3$var$logMarker = "DVD Homepage: ";
function $2e011c8e26481ef3$var$startDVD() {
    var html = document.querySelector("html");
    screen.width >= 800 && html.classList.contains("touch");
    {
        // var box = document.getElementById('dvd'),
        var loaded = false, firstRun = true;
        console.log($2e011c8e26481ef3$var$logMarker + "Initialised with " + $2e011c8e26481ef3$var$colors.length + " videos.");
        init();
        smoothStart();
        // //slow on hover
        // document.getElementById("dvd").addEventListener("mouseover", function(){
        //     speed = 0;
        // });
        // document.getElementById("dvd").addEventListener("mouseout", function(){
        //     speed = 4;
        // });
        // reset constraints on resize
        // window.addEventListener('resize', function(argument) {
        //   clearTimeout(timeout);
        //   timeout = setTimeout(update, 100);
        // }, false);
        function init() {
            setTimeout(()=>{
                // clearInterval(timerId);
                // document.getElementById("static").style.zIndex = '-1';
                // document.getElementById("static").style.opacity = '0';
                firstRun = false;
            }, 100);
            document.querySelector("#dvd").style.opacity = "1";
            if (loaded == false) {
                if (firstRun == false && isInViewport($2e011c8e26481ef3$var$box)) {
                    // if ((ww > box.getBoundingClientRect()['left'] ) && (wh > box.getBoundingClientRect()['top'] )) {
                    console.log($2e011c8e26481ef3$var$logMarker + "Visible");
                    // firstRun = false
                    loaded = true;
                    switchColor();
                }
            // console.log('off screen!')
            }
            $2e011c8e26481ef3$var$request = requestAnimationFrame(init);
            move();
        }
        function smoothStart() {
            document.getElementById("static").style.zIndex = "1";
        }
        // reset constraints
        function update() {
            $2e011c8e26481ef3$var$xMin = -$2e011c8e26481ef3$var$boxLeft;
            $2e011c8e26481ef3$var$yMin = -$2e011c8e26481ef3$var$boxTop;
            $2e011c8e26481ef3$var$xMax = $2e011c8e26481ef3$var$win.innerWidth - $2e011c8e26481ef3$var$boxLeft - $2e011c8e26481ef3$var$boxWidth;
            $2e011c8e26481ef3$var$yMax = $2e011c8e26481ef3$var$win.innerHeight - $2e011c8e26481ef3$var$boxTop - $2e011c8e26481ef3$var$boxHeight;
        }
        function move() {
            setDirection();
            setStyle($2e011c8e26481ef3$var$box, {
                transform: "translate3d(" + $2e011c8e26481ef3$var$translateX + "px, " + $2e011c8e26481ef3$var$translateY + "px, 0)"
            });
        }
        function setDirection() {
            switch($2e011c8e26481ef3$var$direction){
                case "ne":
                    $2e011c8e26481ef3$var$translateX += $2e011c8e26481ef3$var$speed;
                    $2e011c8e26481ef3$var$translateY -= $2e011c8e26481ef3$var$speed;
                    break;
                case "nw":
                    $2e011c8e26481ef3$var$translateX -= $2e011c8e26481ef3$var$speed;
                    $2e011c8e26481ef3$var$translateY -= $2e011c8e26481ef3$var$speed;
                    break;
                case "se":
                    $2e011c8e26481ef3$var$translateX += $2e011c8e26481ef3$var$speed;
                    $2e011c8e26481ef3$var$translateY += $2e011c8e26481ef3$var$speed;
                    break;
                case "sw":
                    $2e011c8e26481ef3$var$translateX -= $2e011c8e26481ef3$var$speed;
                    $2e011c8e26481ef3$var$translateY += $2e011c8e26481ef3$var$speed;
                    break;
            }
            setLimits();
        }
        function isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        }
        function setLimits() {
            if ($2e011c8e26481ef3$var$translateY <= $2e011c8e26481ef3$var$yMin) {
                if ($2e011c8e26481ef3$var$direction == "nw") $2e011c8e26481ef3$var$direction = "sw";
                else if ($2e011c8e26481ef3$var$direction == "ne") $2e011c8e26481ef3$var$direction = "se";
                switchColor();
            }
            if ($2e011c8e26481ef3$var$translateY >= $2e011c8e26481ef3$var$yMax) {
                if ($2e011c8e26481ef3$var$direction == "se") $2e011c8e26481ef3$var$direction = "ne";
                else if ($2e011c8e26481ef3$var$direction == "sw") $2e011c8e26481ef3$var$direction = "nw";
                switchColor();
            }
            if ($2e011c8e26481ef3$var$translateX <= $2e011c8e26481ef3$var$xMin) {
                if ($2e011c8e26481ef3$var$direction == "nw") $2e011c8e26481ef3$var$direction = "ne";
                else if ($2e011c8e26481ef3$var$direction == "sw") $2e011c8e26481ef3$var$direction = "se";
                switchColor();
            }
            if ($2e011c8e26481ef3$var$translateX >= $2e011c8e26481ef3$var$xMax) {
                if ($2e011c8e26481ef3$var$direction == "ne") $2e011c8e26481ef3$var$direction = "nw";
                else if ($2e011c8e26481ef3$var$direction == "se") $2e011c8e26481ef3$var$direction = "sw";
                switchColor();
            }
        }
        function switchColor() {
            if (loaded == true) {
                var color = Math.floor(Math.random() * $2e011c8e26481ef3$var$colors.length);
                while(color == $2e011c8e26481ef3$var$currentColor)color = Math.floor(Math.random() * $2e011c8e26481ef3$var$colors.length);
                document.getElementById("dvd").className = "";
                document.getElementById("dvd").className += $2e011c8e26481ef3$var$colors[color];
                $2e011c8e26481ef3$var$currentColor = color;
                var allVideos = document.querySelectorAll("#dvd video");
                allVideos.forEach((item)=>{
                    item.pause();
                    // item.currentTime = 0;
                    item.parentElement.style.zIndex = 0;
                });
                // console.log('All items paused')
                // var currentvid = "." + colors[color] + "-sub-vid"
                // console.log(currentvid)
                // console.log(colors[color])
                var currentVideoPlay = document.querySelector(`[data-video="${$2e011c8e26481ef3$var$colors[color]}"] video`);
                // console.log(currentVideoPlay)
                // currentVideoPlay.pause()
                // currentVideoPlay.play()
                // console.log(currentVideoPlay)
                document.querySelector(".tv-static").style.zIndex = 2;
                document.querySelector(".tv-static").style.opacity = 0.8;
                document.querySelector(`[data-video="${$2e011c8e26481ef3$var$colors[color]}"]`).style.zIndex = 1;
                setTimeout(()=>{
                    document.querySelector(".tv-static").style.zIndex = 0;
                    document.querySelector(".tv-static").style.opacity = 1;
                }, 300);
                currentVideoPlay.play();
                console.log($2e011c8e26481ef3$var$logMarker + "Video " + $2e011c8e26481ef3$var$colors[color] + " is playing");
            }
        }
        function getVendor() {
            var ua = navigator.userAgent.toLowerCase(), match = /opera/.exec(ua) || /msie/.exec(ua) || /firefox/.exec(ua) || /(chrome|safari)/.exec(ua) || /trident/.exec(ua), vendors = {
                opera: "-o-",
                chrome: "-webkit-",
                safari: "-webkit-",
                firefox: "-moz-",
                trident: "-ms-",
                msie: "-ms-"
            };
            return vendors[match[0]];
        }
        function setStyle(element, properties) {
            var prefix = getVendor(), property, css = "";
            for(property in properties){
                css += property + ": " + properties[property] + ";";
                css += prefix + property + ": " + properties[property] + ";";
            }
            element.style.cssText += css;
        }
    }
}
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector("#dvd")) {
        console.log("starting DVD");
        $2e011c8e26481ef3$var$startDVD();
    }
});
function $2e011c8e26481ef3$var$debounce(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}
function $2e011c8e26481ef3$var$updateBoxValues() {
    $2e011c8e26481ef3$var$ww = $2e011c8e26481ef3$var$win.innerWidth, $2e011c8e26481ef3$var$wh = $2e011c8e26481ef3$var$win.innerHeight, $2e011c8e26481ef3$var$boxWidth = $2e011c8e26481ef3$var$box.offsetWidth, $2e011c8e26481ef3$var$boxHeight = $2e011c8e26481ef3$var$box.offsetHeight, $2e011c8e26481ef3$var$boxTop = $2e011c8e26481ef3$var$box.offsetTop, $2e011c8e26481ef3$var$boxLeft = $2e011c8e26481ef3$var$box.offsetLeft, $2e011c8e26481ef3$var$xMin = -$2e011c8e26481ef3$var$boxLeft, $2e011c8e26481ef3$var$yMin = -$2e011c8e26481ef3$var$boxTop, $2e011c8e26481ef3$var$xMax = $2e011c8e26481ef3$var$win.innerWidth - $2e011c8e26481ef3$var$boxLeft - $2e011c8e26481ef3$var$boxWidth, $2e011c8e26481ef3$var$yMax = $2e011c8e26481ef3$var$win.innerHeight - $2e011c8e26481ef3$var$boxTop - $2e011c8e26481ef3$var$boxHeight;
    console.log($2e011c8e26481ef3$var$logMarker + "Viewport resized");
}
const $2e011c8e26481ef3$var$processChange = $2e011c8e26481ef3$var$debounce(()=>$2e011c8e26481ef3$var$updateBoxValues());
window.addEventListener("resize", $2e011c8e26481ef3$var$processChange);

})();
//# sourceMappingURL=main.js.map
